export const skills = {
  frontend: ['Angular', 'React.js', 'Next.js', 'TypeScript', 'JavaScript', 'RxJS', 'NgRx', 'Ionic Framework', 'HTML', 'CSS', 'SCSS', 'Tailwind CSS'],
  backend: ['ASP.NET', 'C#', 'Node.js', 'Nest.js', 'Loopback4', 'MongoDB', 'SQL', 'MSSQL', 'PostgreSQL'],
  other: ['Git', 'Payment Integrations', 'AI-Assisted Development', 'Web Development', 'Full Stack Development'],
  alsoFamiliar: ['Express.js', 'Python', 'Solidity', 'p5.js', 'Unity', 'Data Science', 'Machine Learning']
};

export interface Project {
  title: string;
  description: string;
  tech: string[];
  github?: string;
  liveUrl?: string;
  year?: string;
}

export const projects: Project[] = [];

export const experiences = [
  {
    title: "Full Stack Software Engineer",
    company: "Alpata Teknoloji",
    period: "Dec 2025 – Present",
    responsibilities: [
      "Developing and maintaining a salesforce automation application using .NET and Angular, delivering end-to-end features across the full stack",
      "Designing and implementing virtual POS and bank integration modules, ensuring secure and reliable payment processing workflows",
      "Building RESTful APIs with .NET to support complex business logic for sales tracking, reporting, and customer management",
      "Collaborating with cross-functional teams to translate business requirements into scalable technical solutions"
    ]
  },
  {
    title: "Senior Specialist Software Developer",
    company: "ETIYA",
    period: "Aug 2024 – Dec 2025",
    responsibilities: [
      "Developed and maintained advanced Angular-based frontend applications for one of Europe's largest telecom providers — customer service, web shop, and subscription management interfaces",
      "Implemented robust state management solutions using NgXs, optimizing performance and scalability of large-scale, complex systems",
      "Collaborated with UX teams, software architects, and business analysts to deliver next-generation telecom service interfaces adhering to accessibility standards",
      "Proactively identified, diagnosed, and resolved critical bugs, significantly improving application stability and performance"
    ]
  },
  {
    title: "Frontend Developer & Team Lead",
    company: "Rapider AI",
    period: "Dec 2020 – Feb 2024",
    responsibilities: [
      "Contributed to critical decision-making and project architecture development with the core development team",
      "Managed integration, sprint planning, and training of a high-performing software engineering team of 4 developers",
      "Architected an interactive low-code BPMN diagram builder using dxDiagram and AntV6, enabling intuitive drag-and-drop business process management",
      "Drove API development and consumption, facilitating effective collaboration between frontend and backend teams",
      "Designed and implemented a comment and notification system using Angular components deployed across the project",
      "Implemented backend services and REST APIs using Loopback4, ensuring full-stack functionality of the system"
    ]
  }
];

export const education = [
  {
    degree: "Bachelor of Science in Software Engineering",
    institution: "Bahcesehir University",
    period: "2019 - 2023",
    details: [
      "Developed capstone project comparing edge detection algorithms for skin lesion segmentation",
      "Demonstrated proficiency in data science, algorithms, advanced networks, web development, and software architecture"
    ]
  },
  {
    degree: "Bachelor of Science in Architecture",
    institution: "Politecnico di Milano",
    period: "2018 - 2019",
    details: []
  },
  {
    degree: "Engineering preparation and Italian language school",
    institution: "Scuola Leonardo da Vinci",
    period: "2017 - 2018",
    details: [
      "Took Engineering and Architecture preparation course",
      "Studied Italian language to C1 level"
    ]
  },
  {
    degree: "High School",
    institution: "TED Eskişehir College",
    period: "2013 - 2017",
    details: []
  }
];
